import { Constants, Enum, TableRowModel } from '@examdojo/supabase';
import { SvgIcon } from '@examdojo/core/icon';

export type Program = Enum<'program', 'categories'>;
export const PROGRAMS = Constants.categories.Enums.program;

export type ProgramMetadata = Omit<TableRowModel<'programs', 'categories'>, 'created_at' | 'updated_at' | 'icon'> & {
  icon: SvgIcon | null;
};
